import React from 'react';
import FingerKey from './FingerKey';

interface TutorialHelperProps {
  lessonId: string | number;
}

const TutorialHelper: React.FC<TutorialHelperProps> = ({ lessonId }) => {
  let content: React.ReactElement | null = null;

  switch (lessonId) {
    case 'tutorial-1':
    case 'tutorial-15':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice all 8 <strong>Home Row</strong> keys. Feel for the bumps on <strong>F</strong> and <strong>J</strong>.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="a" /><FingerKey fingerIndex={1} label="s" /><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={7} label="l" /><FingerKey fingerIndex={8} label=";" /></div>
        </div>);
      break;
    case 'tutorial-2':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Right Index Finger</strong> reach. Move your finger from <strong>J</strong> up to <strong>U</strong> and back.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="u" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-3':
    case 'tutorial-4':
    case 'tutorial-5':
    case 'tutorial-6':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice with your <strong>Index Fingers</strong> on <strong>F</strong> and <strong>J</strong>. Use your <strong>Thumbs</strong> for the Spacebar.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-7':
    case 'tutorial-8':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Time for the <strong>Middle Fingers</strong>. Press <strong>D</strong> with your <strong>Left Middle</strong> and <strong>K</strong> with your <strong>Right Middle</strong>.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-9':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Let's combine your <strong>Index</strong> and <strong>Middle</strong> fingers. Practice <strong>F, J, D,</strong> and <strong>K</strong>.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-10':
    case 'tutorial-11':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Now for the <strong>Ring Fingers</strong>. Press <strong>S</strong> with your <strong>Left Ring</strong> and <strong>L</strong> with your <strong>Right Ring</strong>.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={1} label="s" /><FingerKey fingerIndex={7} label="l" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-12':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Now let's combine all six keys: <strong>S, L, D, K, F,</strong> and <strong>J</strong>. Keep your fingers on the home row!</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={1} label="s" /><FingerKey fingerIndex={7} label="l" /><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={5} label="j" /></div>
        </div>);
      break;
    case 'tutorial-13':
    case 'tutorial-14':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Time for the <strong>Pinky Fingers</strong>. Press <strong>A</strong> with your <strong>Left Pinky</strong> and <strong>;</strong> with your <strong>Right Pinky</strong>.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="a" /><FingerKey fingerIndex={8} label=";" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-16':
    case 'tutorial-17':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Index Finger</strong> reaches. Press <strong>G</strong> with your <strong>Left Index Finger</strong> (from F) and <strong>H</strong> with your <strong>Right Index Finger</strong> (from J).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={3} label="g" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="h" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-18':
    case 'tutorial-19':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Let's practice words using all the <strong>Home Row</strong> keys you've learned.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="a" /><FingerKey fingerIndex={1} label="s" /><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={3} label="g" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="h" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={7} label="l" /></div>
        </div>);
      break;
    case 'tutorial-20':
    case 'tutorial-21':
    case 'tutorial-24':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Index Finger</strong> reaches. Press <strong>R</strong> with your <strong>Left Index</strong> (from F) and <strong>U</strong> with your <strong>Right Index</strong> (from J).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={3} label="r" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="u" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-22':
    case 'tutorial-25':
    case 'tutorial-26':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Let's practice words using the <strong>R</strong> and <strong>U</strong> keys. Remember your home row!</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="a" /><FingerKey fingerIndex={1} label="s" /><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={3} label="r" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="u" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={7} label="l" /><FingerKey fingerIndex={5} label="h" /></div>
        </div>);
      break;
    case 'tutorial-23':
    case 'tutorial-27':
    case 'tutorial-28':
    case 'tutorial-29':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Middle Finger</strong> reaches. Press <strong>E</strong> with your <strong>Left Middle</strong> (from D) and <strong>I</strong> with your <strong>Right Middle</strong> (from K).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={2} label="e" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={6} label="i" /><FingerKey fingerIndex={4} label="Space" /></div>
        </div>);
      break;
    case 'tutorial-32':
       content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Top Row, Left Hand</strong> keys. Reach up from the home row.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="q" /><FingerKey fingerIndex={1} label="w" /><FingerKey fingerIndex={2} label="e" /><FingerKey fingerIndex={3} label="r" /><FingerKey fingerIndex={3} label="t" /></div>
        </div>);
      break;
    case 'tutorial-33':
       content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Top Row, Right Hand</strong> keys. Reach up from the home row.</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={5} label="y" /><FingerKey fingerIndex={5} label="u" /><FingerKey fingerIndex={6} label="i" /><FingerKey fingerIndex={7} label="o" /><FingerKey fingerIndex={8} label="p" /></div>
        </div>);
      break;
    case 'tutorial-35':
    case 'tutorial-36':
    case 'tutorial-37':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Ring Finger</strong> reaches. Press <strong>W</strong> (from S) and <strong>O</strong> (from L).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={1} label="s" /><FingerKey fingerIndex={1} label="w" /><FingerKey fingerIndex={7} label="l" /><FingerKey fingerIndex={7} label="o" /></div>
        </div>);
      break;
    case 'tutorial-39':
    case 'tutorial-40':
    case 'tutorial-41':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice <strong>Q</strong> (Left Pinky) and <strong>Y</strong> (Right Index).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="a" /><FingerKey fingerIndex={0} label="q" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="y" /></div>
        </div>);
      break;
    case 'tutorial-42':
    case 'tutorial-43':
    case 'tutorial-44':
       content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice <strong>P</strong> (Right Pinky) and <strong>T</strong> (Left Index).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={8} label=";" /><FingerKey fingerIndex={8} label="p" /><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={3} label="t" /></div>
        </div>);
      break;
    case 'tutorial-52':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Index Finger</strong> reaches to the bottom row. Press <strong>V</strong> (from F) and <strong>M</strong> (from J).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={3} label="v" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="m" /></div>
        </div>);
      break;
    case 'tutorial-57':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Middle Finger</strong> reaches. Press <strong>C</strong> (from D) and <strong>,</strong> (from K).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={2} label="d" /><FingerKey fingerIndex={2} label="c" /><FingerKey fingerIndex={6} label="k" /><FingerKey fingerIndex={6} label="," /></div>
        </div>);
      break;
    case 'tutorial-64':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Ring Finger</strong> reaches. Press <strong>X</strong> (from S) and <strong>.</strong> (from L).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={1} label="s" /><FingerKey fingerIndex={1} label="x" /><FingerKey fingerIndex={7} label="l" /><FingerKey fingerIndex={7} label="." /></div>
        </div>);
      break;
    case 'tutorial-69':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the <strong>Pinky Finger</strong> reaches. Press <strong>Z</strong> (from A) and <strong>/</strong> (from ;).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="a" /><FingerKey fingerIndex={0} label="z" /><FingerKey fingerIndex={8} label=";" /><FingerKey fingerIndex={8} label="/" /></div>
        </div>);
      break;
    case 'tutorial-75':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Practice the final <strong>Index Finger</strong> reaches. Press <strong>B</strong> (from F) and <strong>N</strong> (from J).</p>
          <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={3} label="b" /><FingerKey fingerIndex={5} label="j" /><FingerKey fingerIndex={5} label="n" /></div>
        </div>);
      break;
    case 'tutorial-92':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Trust your muscle memory. Keep your eyes fixed on the screen, not your hands.</p>
        </div>
      );
      break;
    case 'tutorial-102':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Sit up straight with your feet flat on the floor. Keep your wrists straight and relaxed to avoid strain.</p>
        </div>
      );
      break;
    case 'tutorial-120':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">Use the small bumps on the <strong>F</strong> and <strong>J</strong> keys to find your home row position without looking.</p>
           <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={3} label="f" /><FingerKey fingerIndex={5} label="j" /></div>
        </div>
      );
      break;
    case 'tutorial-122':
    case 'tutorial-138':
      content = (
        <div>
          <p className="text-center text-gray-700 mb-4">To type a capital letter, hold down a <strong>Shift</strong> key with your pinky finger, and press the letter key with the correct finger on the other hand.</p>
           <div className="flex justify-center flex-wrap gap-x-4 gap-y-2"><FingerKey fingerIndex={0} label="Shift" /><FingerKey fingerIndex={8} label="Shift" /></div>
        </div>
      );
      break;
    default:
        content = null;
  }

  if (!content) return null;

  return (
    <div className="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
      {content}
    </div>
  );
};

export default TutorialHelper;